<template>
  <v-card flat>
    <v-card-text class="pa-0">
      <div class="py-3 mx-4">
        <v-skeleton-loader
          v-if="loading"
          type="table"
          class="mb-4"
        ></v-skeleton-loader>

        <div v-else-if="!items || !items.length" class="text-center py-8">
          <v-icon size="64" color="grey lighten-1">mdi-calendar-blank</v-icon>
          <div class="text-h6 text-h4 mt-2">沒有特休紀錄</div>
          <div class="text-body-2 text-h4">沒有資料可以顯示</div>
        </div>

        <template v-else>
          <v-simple-table class="py-3">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">員工</th>
                  <th class="text-left">開始時間</th>
                  <th class="text-left">結束時間</th>
                  <th class="text-left">請假(小時)</th>
                  <th class="text-left">請假(天)</th>
                  <th class="text-left">事由</th>
                  <th class="text-left">狀態</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>{{ item.user ? item.user.name : "-" }}</td>
                  <td>{{ formatDateTime(item.start_time) }}</td>
                  <td>{{ formatDateTime(item.end_time) }}</td>
                  <td>{{ formatHours(item.leave_minutes) }}</td>
                  <td>{{ formatDuration(item.leave_minutes) }}</td>
                  <td>{{ item.reason || "-" }}</td>
                  <td>
                    {{ item.approval_status }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <div class="text-center my-4">
            <v-pagination
              v-model="page"
              :length="pageCount"
              @input="fetchCompanyAnnualLeaves"
              prev-icon="fa fa-angle-left"
              next-icon="fa fa-angle-right"
              color="#cb0c9f"
              circle
            ></v-pagination>
          </div>
        </template>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatDateTime } from "@/utils/time";

export default {
  name: "CompanyAnnualLeaveRecordsWidget",
  props: {
    selectedCompany: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      items: [],
      page: 1,
      itemsPerPage: 15, // Default from request example was 20, but 15 is standard in other widgets. Sticking to 15 or 20? Request url said limit=20. I will use 20 to match request.
      totalItems: 0,
      loading: false,
      fetchError: false,
      totalPages: 1,
    };
  },
  computed: {
    pageCount() {
      return this.totalPages || 1;
    },
  },
  watch: {
    selectedCompany: {
      handler() {
        this.fetchCompanyAnnualLeaves();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async fetchCompanyAnnualLeaves() {
      this.loading = true;
      this.items = [];
      this.fetchError = false;

      try {
        const companyId = this.selectedCompany ? this.selectedCompany.id : null;
        if (!companyId) return;

        const params = new URLSearchParams({
          page: String(this.page),
          limit: String(this.itemsPerPage),
          company_id: String(companyId),
        });

        const response = await this.$axios.get(
          `/api/annual-leaves/company/leave-records?${params.toString()}`
        );
        const payload = response && response.data ? response.data : {};
        const newItems = Array.isArray(payload.data) ? payload.data : [];
        const pagination = payload.pagination || {};

        this.totalItems = Number(pagination.totalItems) || newItems.length || 0;
        this.totalPages = Number(pagination.totalPages) || 1;

        this.items = newItems;
      } catch (error) {
        this.items = [];
        this.totalItems = 0;
        this.fetchError = true;
        this.$emit("error", {
          title: "取得公司特休紀錄失敗",
          message:
            (error && (error.response?.data?.message || error.message)) ||
            "請稍後再試",
        });
      } finally {
        this.loading = false;
      }
    },
    formatDateTime(val) {
      return formatDateTime(val);
    },
    formatHours(minutes) {
      if (!minutes && minutes !== 0) return "0";
      const hours = minutes / 60;
      return Number.isInteger(hours) ? hours.toString() : hours.toFixed(1);
    },
    formatDuration(minutes) {
      if (!minutes && minutes !== 0) return "0";
      const days = minutes / 480;
      return Number.isInteger(days) ? days.toString() : days.toFixed(2);
    },
    getStatusColor(status) {
      if (status === "審核通過") return "success";
      if (status === "待審核") return "warning";
      if (status === "審核拒絕") return "error";
      return "grey";
    },
  },
};
</script>

<style scoped></style>
